import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Album } from "../../types/Album";
import { getAlbumThumbnail, postAlbumRating } from "../apis/music-api";
import { AuthenticationContext } from "../authentication/AuthenticationContext";
import { FileResponse } from "../../types/FileResponse";
import { BeatLoader } from "react-spinners";
import { Box, Rating, Stack, Typography, useMediaQuery } from "@mui/material";
import callApi from "../call-api/call-api";
import { trackDuration } from "../text-helper/text-helper";

type AlbumProps = {
    letter: string,
    artistName: string,
    album: Album,
}

const GridAlbum = (props: AlbumProps) => {
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ thumbnail, setThumbnail ] = useState<FileResponse>();
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const [rating, setRating] = useState<number | null>(props.album.rating ?? 0);
    
    useEffect(() => {
        if (props.album.title !== undefined && props.album.year > 0) {
            callApi<FileResponse>(getAlbumThumbnail(getAccessToken(), props.artistName, `${props.album.year} - ${props.album.title}`), setThumbnail);
        }
    }, [props.artistName, props.album.year, props.album.title, getAccessToken]);

    const handleRatingChange = (newValue: number | null) => {
        if (newValue === null) {
            return;
        }

        setRating(newValue);
        callApi<boolean>(postAlbumRating(getAccessToken(), props.artistName, `${props.album.year} - ${props.album.title}`, newValue.toString()), () => {});
    }

    return (
        <Stack direction={isSmall ? "column" : "row"}>
            <Box
                alignItems={'center'}
                justifyContent={'center'}
                sx={{
                    width: '120px',
                    height: '120px'
                }}
            >
                {thumbnail?.fileContents !== undefined &&
                    <Link to={`/letters/${props.letter}/artists/${props.artistName}/albums/${props.album.year} - ${props.album.title}`}>
                        <img width={'120px'} height={'120px'} alt={`Cover`} src={`data:image/jpeg;base64,${thumbnail?.fileContents}`} />
                    </Link>
                }
                <BeatLoader
                    loading={thumbnail?.fileContents === undefined}
                    size={24}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </Box>
            <Box
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    textAlign: 'left',
                    paddingLeft: isSmall ? '0px' : '12px',
                }}
            >
                <div><b>{props.album.year}</b></div>
                <div>
                    <Link
                        style={{ color: 'inherit' }}
                        to={`/letters/${props.letter}/artists/${props.artistName}/albums/${props.album.year} - ${props.album.title}`}
                    >
                        {props.album.title}
                    </Link>
                </div>
                <div>
                    <Rating name="album-rating" value={rating} precision={1.0} onChange={(event, newValue) => handleRatingChange(newValue)} />
                </div>
            </Box>
            <Box
                sx={{
                    width: '120px',
                    textAlign: isSmall ? 'left' : 'right'
                }}
            >
                <Typography variant="body1">{props.album.trackCount} tracks</Typography>
                <Typography variant="body1">({trackDuration(props.album.totalDuration)})</Typography>
            </Box>
        </Stack>
    );
}

export default GridAlbum;